module.exports = __webpack_public_path__ + "img/product_icon.6abdc106.png";